import { render } from "./JiraStatusSelect.vue?vue&type=template&id=1015d483&scoped=true"
import script from "./JiraStatusSelect.vue?vue&type=script&lang=js"
export * from "./JiraStatusSelect.vue?vue&type=script&lang=js"

import "./JiraStatusSelect.vue?vue&type=style&index=0&id=1015d483&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1015d483"]])

export default __exports__